/** Delay before opening first-visit page guides (iOS viewport settle). */
export const PUBLIC_PAGE_GUIDE_OPEN_DELAY_MS = 400;
